function HeartIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      fill="none"
      viewBox="0 0 14 12"
      style={{cursor: "pointer"}}
    >
      <path
        fill="#F33333"
        stroke="#F33333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.033"
        d="M12.081 1.884a3.016 3.016 0 00-4.267 0l-.582.581-.581-.58A3.017 3.017 0 102.384 6.15l.581.582L7.232 11 11.5 6.733l.581-.582a3.016 3.016 0 000-4.267z"
      ></path>
    </svg>
  );
}

function NoHeart() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      fill="none"
      viewBox="0 0 14 12"
      style={{cursor: "pointer"}}
    >
      <path
        fill="#FFF"
        stroke="rgba(77, 77, 77, 1)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.033"
        d="M12.081 1.884a3.016 3.016 0 00-4.267 0l-.582.581-.581-.58A3.017 3.017 0 102.384 6.15l.581.582L7.232 11 11.5 6.733l.581-.582a3.016 3.016 0 000-4.267z"
      ></path>
    </svg>
  );
}

export { HeartIcon, NoHeart };